import React, {useContext, useState} from 'react';
import SignInFirstPage from 'components/login/SignInFirstPage';
import 'styles/login/SignInPopup.css';
import SetNicknameTab from 'components/login/SetNicknameGoogleUser';
import BasicSignInTab from 'components/login/basic/BasicSignInTab';
import {PopupContext} from 'popup/Popup';
import OtpTab from "./basic/OtpTab";

const SignInPopup = () => {
    const [showWelcomePage, setShowWelcomePage] = useState(true);
    const [showUsernameField, setShowUsernameField] = useState(false);
    const [showBasicSignInTab, setShowBasicSignInTab] = useState(false);
    const {setDisableBackgroundClose, setDisableEscapeClose} = useContext(PopupContext);
    const [otpPayload, setOtpPayload] = useState(null);

    const hideEverything = () => {
        setShowUsernameField(false);
        setShowBasicSignInTab(false);
        setShowWelcomePage(false);
    };

    const onMissingUserName = () => {
        hideEverything();
        setOtpPayload(null);
        setDisableEscapeClose(true);
        setShowUsernameField(true);
    };

    const onUsernameAndPassword = () => {
        hideEverything();
        setDisableBackgroundClose(true);
        setShowBasicSignInTab(true);
    };

    const handleOtpRequested = ({otpKey, email}) => {
        hideEverything();
        setDisableEscapeClose(true);
        setOtpPayload({otpKey, email});
    };

    return (
        <div className="sign-in-popup-container">
            {showWelcomePage && (
                <SignInFirstPage
                    onMissingUserName={onMissingUserName}
                    onUserNameAndPassword={onUsernameAndPassword}
                />
            )}
            {showBasicSignInTab && (
                <BasicSignInTab onMissingUserName={onMissingUserName} handleOtpRequested={handleOtpRequested}/>
            )}
            {otpPayload && (
                <OtpTab
                    otpKey={otpPayload.otpKey}
                    email={otpPayload.email}
                    onMissingUserName={onMissingUserName}
                />
            )}
            {showUsernameField && (
                <SetNicknameTab/>
            )}
        </div>
    );
};

export default SignInPopup;
